import { render, staticRenderFns } from "./FacebookPageCard.vue?vue&type=template&id=141dbb2f&scoped=true"
import script from "./FacebookPageCard.vue?vue&type=script&lang=js"
export * from "./FacebookPageCard.vue?vue&type=script&lang=js"
import style0 from "./FacebookPageCard.vue?vue&type=style&index=0&id=141dbb2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141dbb2f",
  null
  
)

export default component.exports